import isWeb from './isWeb';

export default function cloneObject<T>(data: T): T {
  if (data === null || typeof data !== 'object') {
    return data;
  }

  if (data instanceof Date) {
    return new Date(data) as T;
  }

  const isBlobInstance = typeof Blob !== 'undefined' && data instanceof Blob;
  const isFileListInstance =
    typeof FileList !== 'undefined' && data instanceof FileList;

  if (isWeb && (isBlobInstance || isFileListInstance)) {
    return data;
  }

  const isArray = Array.isArray(data);
  const prototype = Object.getPrototypeOf(data);

  if (!isArray && prototype && prototype.constructor !== Object) {
    return data;
  }

  const copy = isArray ? new Array(data.length) : Object.create(prototype);

  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      copy[key] = cloneObject(data[key]);
    }
  }

  return copy;
}
